import { render, staticRenderFns } from "./StartGiveaway.vue?vue&type=template&id=08aff47c&"
import script from "./StartGiveaway.vue?vue&type=script&lang=js&"
export * from "./StartGiveaway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports